import { WebchatConfiguration, WebchatConfigurationKeys } from './types';

const stestConfig: WebchatConfiguration = {
  [WebchatConfigurationKeys.APP_INSIGHTS_CONNECTION_STRING]:
    'InstrumentationKey=15f13c55-26de-4b6d-ae95-cf27f80fa5e9;IngestionEndpoint=https://northeurope-0.in.applicationinsights.azure.com/',
  [WebchatConfigurationKeys.GOOGLE_TAG_MANAGER_KEY]: 'GTM-T366PF4',
};

export default stestConfig;
